import { Component } from '@angular/core';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import { HttpClient } from '@angular/common/http';

import { BaseUrl } from '../../../BaseUrl';
import { RichTextEditorService } from '../../Services/rich-text-editor.service';


@Component({
  selector: 'app-rich-texteditor',
  templateUrl: './rich-texteditor.component.html',
  styleUrls: ['./rich-texteditor.component.css'],
  standalone:false
})
export class RichTexteditorComponent {
  title = 'demo';
  public Editor = DecoupledEditor;
  private editorInstance: any;
  public editorContent!: string;

  public config = {
    ckfinder: {
      uploadUrl: 'upload',
    },
  };
  constructor(
    private http: HttpClient,
    private editorService: RichTextEditorService
  ) {
    this.editorService.getEditorContent().subscribe((content) => {
      this.editorContent = content;
    });
  }
  public onReady(editor: any): void {
    editor.plugins.get('FileRepository').createUploadAdapter = (
      loader: any
    ) => {
      return new UploadAdapter(loader, this.http);
    };
    const element = editor.ui.getEditableElement();
    const parent = element.parentElement;
    parent.insertBefore(editor.ui.view.toolbar.element, element);
    editor.plugins
      .get('Clipboard')
      .on('inputTransformation', (evt: any, data: any) => {
        if (data.dataValue) {
          const plainText = editor.plugins
            .get('Clipboard')
            .toText(data.dataValue);
          const div = document.createElement('div');
          div.innerHTML = plainText;
          const processedHtml = editor.plugins
            .get('HTMLToPlainText')
            .toView(div.innerHTML);
          const viewFragment = editor.data.processor.toView(processedHtml);
          data.dataValue = viewFragment;
        }
      });

    editor.config.language = 'ar';
    editor.config.contentsLangDirection = 'rtl';
  }

  onContentChange(newContent: string): void {
    this.editorService.setEditorContent(newContent);
  }
}

class UploadAdapter {
  loader: any;
  http: HttpClient;

  constructor(loader: any, http: HttpClient) {
    this.loader = loader;
    this.http = http;
  }

  upload(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.loader.file
        .then((file: File) => {
          const formData = new FormData();
          formData.append('file', file, file.name);
          const uploadUrl = 'upload';
          const mainPoint = BaseUrl;
          const baseUrl = mainPoint;
          this.http.post(uploadUrl, formData).subscribe(
            (response: any) => {
              const imageUrl = baseUrl + response.imageUrl; // Modify this to extract the image URL from the server response
              resolve({
                default: imageUrl,
              });
            },
            (error: any) => {
              reject(error);
            }
          );
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  abort(): void {}
}

